// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".controlsWrapper__1AMNt{padding:0 0 20px 0;background-color:white}.title__yAbQs{font-weight:600}.giftCardDetails__3ZnI3{display:flex;gap:5px}.title__yAbQs{font-weight:600}.content__VFPc_{font-weight:400}\n", "",{"version":3,"sources":["/home/runner/work/honeylove-web/honeylove-web/src/components/GiftCardControlsDesktop.module.scss"],"names":[],"mappings":"AAAA,wBACE,kBAAmB,CACnB,sBAAuB,CACxB,cAGC,eAAgB,CACjB,wBAGC,YAAa,CACb,OAAQ,CACT,cAGC,eAAgB,CACjB,gBAGC,eAAgB","file":"GiftCardControlsDesktop.module.scss","sourcesContent":[".controlsWrapper {\n  padding: 0 0 20px 0;\n  background-color: white;\n}\n\n.title {\n  font-weight: 600;\n}\n\n.giftCardDetails {\n  display: flex;\n  gap: 5px;\n}\n\n.title {\n  font-weight: 600;\n}\n\n.content {\n  font-weight: 400;\n}\n"]}]);
// Exports
exports.locals = {
	"controlsWrapper": "controlsWrapper__1AMNt",
	"title": "title__yAbQs",
	"giftCardDetails": "giftCardDetails__3ZnI3",
	"content": "content__VFPc_"
};
module.exports = exports;
